import _ from 'lodash';
import { useTranslation, Trans } from 'react-i18next';
import { ReactComponent as DiamondIcon } from '../../../img/bookings/diamond.svg';
import './FutureBenefits.scss';

const FutureBenefits = ({ earnedDiamonds, earnedPoints }) => {
    const { t } = useTranslation();

    const hasDiamonds = _.isNumber(earnedDiamonds) && earnedDiamonds > 0;
    const hasPoints = _.isNumber(earnedPoints) && earnedPoints > 0;

    if (!hasDiamonds && !hasPoints) {
        return null;
    }

    const formatNumber = (num) => {
        return num.toLocaleString('en-US');
    };

    return (
        <div className="future-benefits">
            <DiamondIcon />
            <div className="future-benefits-content">
                <div className="future-benefits-title">{t('FutureBenefitsGranted')}</div>
                <div className="future-benefits-items">
                    {hasPoints && (
                        <span className="future-benefits-item">
                            <Trans
                                i18nKey={earnedPoints === 1 ? 'FutureBenefitsPoint' : 'FutureBenefitsPoints'}
                                values={{ count: formatNumber(earnedPoints) }}
                                components={{ bold: <span className="future-benefits-item-bold" /> }}
                            />
                        </span>
                    )}
                    {hasPoints && hasDiamonds && <span className="future-benefits-item">+</span>}
                    {hasDiamonds && (
                        <span className="future-benefits-item">
                            <Trans
                                i18nKey={earnedDiamonds === 1 ? 'FutureBenefitsDiamond' : 'FutureBenefitsDiamonds'}
                                values={{ count: formatNumber(earnedDiamonds) }}
                                components={{ bold: <span className="future-benefits-item-bold" /> }}
                            />
                        </span>
                    )}
                </div>
                     {(hasPoints || hasDiamonds) && (<div>
                             <Trans
                                i18nKey="FuturePointsAndDiamondsSuffix"
                                components={{ bold: <span className="future-benefits-item-bold" /> }}
                            />
                </div>)}
            </div>
        </div>
    );
};

export default FutureBenefits;
